import { LOCALES } from 'utils/languageUtils';

/** @type {Readonly<Record<LOCALES.ENGLISH | LOCALES.GREEK, Record<string, string>>>} */
const APP_LABELS = Object.freeze({
  [LOCALES.ENGLISH]: {
    documentTitle: 'Telekom - A better world, for all',
  },
  [LOCALES.GREEK]: {
    documentTitle: 'Telekom - Ένας καλύτερος κόσμος για όλους',
  },
});
export default APP_LABELS;
